import type { PageContext } from "vike/types";
import type { Data } from "./+data";
import { storeSeoTitle } from "@/lib/storeSeoCopy";

// C4: single <title>/og:title owner (vike-react renders both from this).
// D-09: review-intent title (never "0.0"); the copy lives in lib/storeSeoCopy.ts, shared with
// +description.ts and +Head.tsx so the three cannot drift.
export default function title(pageContext: PageContext): string | null {
  const store = (pageContext.data as Data | undefined)?.store;
  return store ? storeSeoTitle(store) : null;
}
